import { CartItem } from '../types/cart'

export type CartProviderIdentity = {
  displayCode: string
  inputCode: string
  name: string
}

/**
 * Return the identity shape exposed by the channel's provider-visibility policy.
 * Existing channels expose provider; anonymised channels expose rateGroup instead.
 */
export const getCartProviderIdentity = (
  item: CartItem
): CartProviderIdentity => ({
  displayCode:
    item.provider?.displayProviderCode ?? item.rateGroup?.rateGroupCode ?? '',
  inputCode: item.provider?.providerCode ?? item.rateGroup?.rateGroupCode ?? '',
  name: item.provider?.name ?? item.rateGroup?.name ?? ''
})

/**
 * GraphQL keeps grpcInput.providerCode non-null for compatibility, while hidden-provider
 * reservation responses intentionally return providerCode as null. Prefer the public rate
 * group when present and otherwise send the empty legacy placeholder; the BFF resolves the
 * authoritative provider from Cart and never trusts this display projection.
 */
export const getPrimitiveProviderInputCode = (identity: {
  providerCode?: string | null
  rateGroupCode?: string | null
}): string => identity.providerCode || identity.rateGroupCode || ''
